import { Pipe, PipeTransform } from '@angular/core';

import {GenderDBChoices} from '../../enums/gender.enum';

@Pipe({
  name: 'Gender'
})
export class GenderPipe implements PipeTransform {
  transform(value): unknown {
    switch (value) {
      case GenderDBChoices.male:
        return 'Male';
      case GenderDBChoices.female:
        return 'Female';
      case GenderDBChoices.other:
        return 'Other';
      case GenderDBChoices.notStated:
        return '-';
    }
    return null;
  }
}
